import React from 'react';
import { connect } from 'react-redux'
import { Redirect, Route } from 'react-router-dom';
import {
  IonContent,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonLoading,
  IonToast,
  IonPage,
} from '@ionic/react';
import { homeOutline, cartOutline, personOutline, cubeOutline, receiptOutline } from 'ionicons/icons';
import Products from '../pos/products/Products';
import Cart from '../pos/cart/Cart';
import Orders from '../pos/orders/Orders';
import Home from '../pos/home/Home';
import Contacts from '../pos/contacts/Contacts';
import PosActions from '../../actions/PosActions';
import { getLoginApp, getPermissions } from '../../utils/functions';
import { Capacitor } from '@capacitor/core';
import UtilActions from '../../actions/UtilActions';
import {
  queryAllLocations,
  createLocationTest,
  queryAllPermisions,
  queryAllConfiguration,
  createConfiguration,
  getConfigurationById,
  updateConfigurationById,
  createPermission
} from "../../data_base_local/dataservice";
interface IProps {
  setData_: any;
  get_: any;
  get_data_module: any;
}

interface IState {
  simpleToast: any;
  response: any;
  datalogin: any;
  loading: any;
  data_default: any;

}

class DashboardPos extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props)
    this.state = {
      response: props.response,
      simpleToast: props.simpleToast,
      datalogin: props.datalogin,
      loading: props.loading,
      data_default: props.data_default

    }
  }

  componentDidMount() {
    this.setState({
      datalogin: getLoginApp()
    });

    this.props.get_({
      typeOption: 'get_data_default',
      user_id: getLoginApp().id,
    }, "api/get_data_default");


  }

  UNSAFE_componentWillReceiveProps(nextProps: any) {
    this.setState({
      simpleToast: nextProps.data.simpleToast,
      response: nextProps.data.response,
      loading: nextProps.data.loading,
      data_default: nextProps.data.data_default

    });
    console.log('nextProps.data.loading', nextProps.data.response);
  }

  onDidDismissToast(e: any) {
    this.props.setData_({ response: {}, simpleToast: false });
  }

  async updatePermissions() {
    let data_permission = getPermissions();
    if (Capacitor.isNativePlatform()) {
      //permisions
      let permisions = await getConfigurationById(2).then();
      if (permisions && permisions.values.length > 0) {
        let id_permisions = permisions.values[0].id;
        await updateConfigurationById(id_permisions, {
          token: '-',
          data_login: JSON.stringify(getPermissions())
        }).then();
      }
    }
  }

  render() {
    const { simpleToast, response, loading, data_default } = this.state;
    if (data_default && data_default.permissions) {
      this.updatePermissions();
    };
    return (
      <IonPage>
        <div id="print-area" className="print-area" style={{ display: 'none', width: 0, height: 0, border: 'none' }} title="Print Area"></div>

        <IonContent className='no-print' fullscreen scrollEvents={true} style={{ borderRadius: '10px' }}>

          <IonLoading
            //color="light"
            cssClass='my-custom-class'
            isOpen={!!(loading && loading.isOpen)}
            message={`${loading && loading.Msg ? loading.Msg : ''}`}
          />
          {
            response && response.Msg ? (
              <IonToast
                isOpen={!!simpleToast}
                color={response && (response.success == 1 || response.success == true) ? 'success' : 'danger'}
                position='top'
                message={`${response && response.Msg ? response.Msg : ''}`}
                duration={1500}
                onDidDismiss={e => this.onDidDismissToast(e)}
              />
            ) : null
          }

          <IonTabs>
            <IonRouterOutlet >
              <Route path="/dashboard_pos/home" component={Home} exact={true} />
              <Route path="/dashboard_pos/products" component={Products} exact={true} />
              <Route path="/dashboard_pos/cart" component={Cart} exact={true} />
              <Route path="/dashboard_pos/orders" component={Orders} exact={true} />
              <Route path="/dashboard_pos/contacts" component={Contacts} exact={true} />

            </IonRouterOutlet>

            <IonTabBar slot="bottom">
              <IonTabButton tab="dashboard_pos/home" href={`/dashboard_pos/home`} >
                <IonIcon icon={homeOutline} />
                <IonLabel>Dashboard</IonLabel>
              </IonTabButton>
              <IonTabButton tab="dashboard_pos/contacts" href={`/dashboard_pos/contacts`}>
                <IonIcon icon={personOutline} />
                <IonLabel>Clientes</IonLabel>
              </IonTabButton>
              <IonTabButton tab="dashboard_pos/products" href={`/dashboard_pos/products`}>
                <IonIcon icon={cubeOutline} />
                <IonLabel>Producto</IonLabel>
              </IonTabButton>

              <IonTabButton tab="dashboard_pos/orders" href={`/dashboard_pos/orders`}>
                <IonIcon icon={receiptOutline} />
                <IonLabel>Facturas</IonLabel>
              </IonTabButton>
              <IonTabButton tab="dashboard_pos/cart" href={`/dashboard_pos/cart`}>
                <IonIcon icon={cartOutline} />
                <IonLabel>Carrito</IonLabel>
              </IonTabButton>
            </IonTabBar>
          </IonTabs>
        </IonContent>
      </IonPage>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data,

  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    setData_: (data: any, name: string) => dispatch(PosActions.setData(data, name)),
    get_: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),
    get_data_module: (fields: any, controller: string) => dispatch(UtilActions.get_(fields, controller)),

  }
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPos);
